<div class="dialog-main">
  <div class="header mt-3 mb-5">
    <span>
      <ng-container *ngIf="!showCloseBtn">        
        <img
          src="/assets/svg/ico-chevron-back-outline.svg"
          class="pointer-cursor move-back my-2"
          (click)="rejectDialog()"
        />
      </ng-container>
    </span>
    <span class="modal-title text-center question">
      <b>
        {{ title }}
      </b>
    </span>

    <span>
      <ng-container *ngIf="showCloseBtn">
        <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="pointer-cursor move-back my-2"
        (click)="rejectDialog()"
      />
      </ng-container>     

    </span>
  </div>

  <div
    class="rounded-top body-container d-flex justify-content-center align-items-center"
  >
    <div class="message w-100 h-100 py-5">
      <div class="my-5 mx-4">
        <div
          class="w-100 h-100 d-flex flex-column justify-content-center align-items-center"
        >
          <p class="question text-center">
            {{ bodyText }}
          </p>
        </div>
        <div
          class="w-100 h-100 d-flex flex-column justify-content-center align-items-center"
        >
          <p class="message text-center">
            {{ footerText }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row my-2">
    <div class="col-12 my-1">
      <button
        class="btn btn-danger px-3 w-100 done-btn"
        type="button"
        (click)="acceptDialog()"
      >
        {{ 'YES' | translate }}
      </button>
    </div>
  </div>

  <div class="row my-2">
    <div class="col-12 my-1">
      <button
        type="button"
        (click)="rejectDialog()"
        class="add-button px-5 py-3 mt1 mb-4 w-100"
      >
        <strong> {{ 'NO' | translate }} </strong>
      </button>
    </div>
  </div>
</div>
